import { Component, Input } from "@angular/core";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { BaseComponent } from "../base.component";
import { Base, ForgetPasswordEnum } from "../_models/index";
import { SessionManagerService } from "../_services/SessionManager/session-manager.service";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";

@Component({
  selector: "registereduser",
  moduleId: module.id,
  templateUrl: "registereduser.component.html",
})
export class RegisteredUserComponent extends BaseComponent {
  @Input() registeredUser: any;
  modalReference: any;
  ForgetPasswordType = ForgetPasswordEnum;
  public ForgotPasswordSendEmail: boolean;

  constructor(
    private modalService: NgbModal,
    public dataService: DataService,
    private alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
    this.ForgotPasswordSendEmail =
      this.sessionManager.features.ForgotPasswordSendEmail;
  }

  run() {}

  open(content) {
    let options: NgbModalOptions = {
      windowClass: "modal-opened searchChild",
    };
    this.modalReference = this.modalService.open(content, options);
  }

  copyToClipBoard(val: string) {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }

  doAction(type) {
    //   	if (!this.registeredUser.email && !this.registeredUser.id)
    let postData = {
      email: this.registeredUser.email,
      id: this.registeredUser.id,
      type: type,
    };
    this.loading = true;
    this.addObservable(
      this.dataService.postEntity("forgot-password", postData, true).subscribe(
        (data) => {
          this.loading = false;

          if (type == ForgetPasswordEnum.COPY && data.url) {
            this.copyToClipBoard(data.url);
            this.alertService.success(this.base.messages["admin_copy_success"]);
          } else if (data.email || data.phone) {
            this.alertService.success(
              this.base.messages["admin_send_to_success"] +
                (data.email ? data.email : data.phone)
            );
          }
        },
        (error) => {
          this.loading = false;
          let body = error.json && error.json();
          this.alertService.error(
            body && body.statusText
              ? this.base.messages[body.statusText]
                ? this.base.messages[body.statusText]
                : decodeURIComponent(body.statusText)
              : (error && error.statusText) || error
          );
        }
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/registereduser/registereduser.component.ts